/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_left': {
    width: 15,
    height: 24,
    viewBox: '0 0 15 24',
    data: '<path pid="0" d="M5.027 12.005l9.536-8.98c.26-.246.406-.58.406-.927 0-.348-.146-.682-.406-.928l-.836-.786A1.441 1.441 0 0012.742 0c-.37 0-.724.138-.986.384L.406 11.074c-.26.248-.406.582-.406.931 0 .35.146.684.406.932l11.34 10.68c.26.246.615.384.985.384s.724-.138.986-.384l.835-.786c.262-.247.408-.58.408-.929 0-.348-.146-.682-.408-.928l-9.525-8.97z" _fill="#fff"/>'
  }
})
